/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

export const updateProjectStatusSchema = z.object({
  name: z.coerce.string(),
});
